import { render } from "./ReferralPage.vue?vue&type=template&id=920b4118"
import script from "./ReferralPage.vue?vue&type=script&lang=js"
export * from "./ReferralPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__